import { ref } from 'vue';
import { useWalletStore } from '@/store/wallet';
import { Apii } from '@/services/api.js';
import { notify } from 'notiwind';

export function useBusinessEntity() {
    const ApiService = new Apii();
    const walletStore = useWalletStore();

    const showAddEntityModal = ref(false);
    const newEntityModel = ref({
        user_id: null,
        name: null,
        type: null,
        tax_id_type: null,
        annual_business_spend: null,
    });

    const openAddEntityModal = (userId) => {
        newEntityModel.value.user_id = userId;
        showAddEntityModal.value = true;
    };

    const closeAddEntityModal = () => {
        showAddEntityModal.value = false;
        newEntityModel.value = {
            user_id: null,
            name: null,
            type: null,
            tax_id_type: null,
            annual_business_spend: null,
        };
    };

    const handleAddBusiness = async (businessData) => {
        try {
            const mappedData = {
                user_id: businessData.userId || businessData.user_id,
                name: businessData.name,
                type: businessData.type,
                tax_id_type: businessData.tax_id_type,
                annual_business_spend: businessData.annual_business_spend
                    ? parseFloat(
                          businessData.annual_business_spend
                              .toString()
                              .replace(/[^0-9.]/g, '')
                      )
                    : null,
            };

            const response = await ApiService.apiCall(
                '/businesses',
                'post',
                mappedData
            );

            if (response.status >= 200 && response.status < 300) {
                closeAddEntityModal();
                await walletStore.getWallet();

                notify(
                    {
                        group: 'success',
                        title: 'Success',
                        text: 'Business entity added successfully!',
                    },
                    4000
                );
            } else {
                throw new Error(
                    response.data?.message || 'Failed to create business entity'
                );
            }
        } catch (error) {
            let errorMessage =
                'Failed to add business entity. Please try again.';
            if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.response?.data?.errors) {
                const validationErrors = Object.values(
                    error.response.data.errors
                ).flat();
                errorMessage = validationErrors.join(', ');
            }

            notify(
                {
                    group: 'error',
                    title: 'Error',
                    text: errorMessage,
                },
                4000
            );
        }
    };

    return {
        showAddEntityModal,
        newEntityModel,
        openAddEntityModal,
        closeAddEntityModal,
        handleAddBusiness,
    };
}
